import { render, staticRenderFns } from "./ReminderLetter.vue?vue&type=template&id=22eb597e&scoped=true&"
import script from "./ReminderLetter.vue?vue&type=script&lang=js&"
export * from "./ReminderLetter.vue?vue&type=script&lang=js&"
import style0 from "./ReminderLetter.vue?vue&type=style&index=0&id=22eb597e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb597e",
  null
  
)

export default component.exports